<template>
  <v-card :loading="loading">
    <v-card-title class="subtitle-2">
      Enemy death heatmap
    </v-card-title>
    <v-card-text v-if="!show || loading" height="350" class="pa-2 caption black--text">
      <v-sheet height="350" class="d-flex justify-center align-center">
        <v-btn
          color="primary"
          :loading="loading"
          @click="show = true"
        >
          Load data
        </v-btn>
      </v-sheet>
    </v-card-text>
    <v-card-text v-else class="pa-2 caption black--text">
      <apexchart type="heatmap" :height="height" :options="chartOptions" :series="series" />
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: false,
      series: [],
      show: false,
      chartOptions: {
        chart: {
          type: 'heatmap',
          animations: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            if (val > 1000000000) {
              return (val / 1000000000).toFixed(1) + 'B'
            } else if (val > 1000000) {
              return (val / 1000000).toFixed(1) + 'M'
            } else if (val > 1000) {
              return (val / 1000).toFixed(1) + 'K'
            } else {
              return val
            }
          },
          style: {
            fontSize: '12px',
            colors: ['#424242'],
          },
        },
        colors: this.generateColorsByLength(0),
        plotOptions: {
          heatmap: {
            distributed: true
          }
        }
      }
    }
  },
  computed: {
    height () {
      return 200 + this.series.length * 20
    }
  },
  watch: {
    async '$route.params' () {
      if (this.show) {
        await this.getData()
      }
    },
    async show (val) {
      if (val) {
        await this.getData()
      }
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-enemy-death/heatmap`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
        return
      } else {
        this.series = data
      }
      this.loading = false
    }
  }
}
</script>
